export enum GameState {
  LOBBY = 0,
  PLAYING = 1,
  POSTGAME = 2
}
